// extracted by mini-css-extract-plugin
export const txtTitle = "v_d";
export const txtSubTitle = "v_f";
export const input = "v_g";
export const btnCreate = "v_bk";
export const errorMsg = "v_m";
export const upload = "v_bl";